// src/models/Service.js
export class Service {
  constructor(data) {
    Object.assign(this, {
      id: data.id,
      therapist_id: data.therapist_id,
      name: data.name,
      price: data.price,
      duration: data.duration, 
      description: data.description,
      status: data.status,
      created_at: data.created_at,
      updated_at: data.updated_at
    });
  }
 }